export default "__VITE_ASSET__BAUsGu1v__"